import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { apiFetch } from '../../api/client'
import { useAuth } from '../../contexts/AuthContext'
import { formatTrialCountdown } from './trialCountdown'

const TrialStatusSchema = z.object({
  active: z.boolean(),
  expires_at: z.string().nullable(),
  server_time: z.string(),
})

export function TrialStatusChip({ projectId }: { projectId: string }) {
  const { t } = useTranslation('workspace')
  const { user } = useAuth()
  const trial = useQuery({
    queryKey: ['generation-trial-status', user?.id ?? null, projectId],
    queryFn: async () => {
      const response = await apiFetch(
        `/projects/${encodeURIComponent(projectId)}/agentic/billing/trial-status`,
      )
      if (!response.ok) throw new Error(`Trial status unavailable: ${response.status}`)
      return TrialStatusSchema.parse(await response.json())
    },
    staleTime: 30_000,
    refetchInterval: 30_000,
  })
  const remaining = trial.data?.active && trial.data.expires_at
    ? formatTrialCountdown(trial.data.expires_at, trial.data.server_time)
    : null
  if (!remaining) return null
  return (
    <span
      data-testid="free-trial-status-chip"
      className="rounded-full border border-success/30 bg-success/10 px-2 py-1 text-xs font-medium text-success"
    >
      {t('sparksBalance.freeTrial', { remaining })}
    </span>
  )
}
